// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview[data-v-71609ba3]{min-height:calc(100vh - var(--admin-bar-height, 0px));top:var(--admin-bar-height,0)}.close[data-v-71609ba3]{position:absolute}", ""]);
// Exports
module.exports = exports;
